import { render } from "./DLCView.vue?vue&type=template&id=54f9a76c"
import script from "./DLCView.vue?vue&type=script&lang=js"
export * from "./DLCView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__